module.exports = __webpack_public_path__ + "components/wind-icon/static/ESE@2x-5c9df52dd77b1b224f938cd7ee6f599e.png";